import { mapState as rootMapState, mapActions as rootMapActions } from 'pinia';
import { usePageStore } from '@/store';

import util from '@/common/util';
import { SET_SEARCH_DATA_READY } from "@/modules/md-search/_store/config"

// import { findSearchBar } from '@/common/utils/find-search-bar';
export const SEARCH_CHANGE_TYPE = 'SEARCH_CHANGE';

export default {
    computed: {
        ...rootMapState(usePageStore, {
            "isSearchCenter": store => store.isSearchCenter
        }),
        hasLocation() {
            if (this.isSearchCenter) {
                try {
                    let condition = {};
                    if (this.searchModule) {
                        condition = JSON.parse(this.searchParams.condition);
                    } else {
                        condition = this.presetFiltersV2 || {};
                    }
                    if (
                        condition.location &&
                        Object.keys(condition.location).length > 0
                    ) {
                        return true;
                    } else {
                        return false;
                    }
                } catch (e) {
                    return false;
                }
            } else {
                if (this.searchModule) {
                    return (
                        !!this.searchParams.key || !!this.searchParams.mapPath  || !!this.searchParams.mapRadius
                    );
                } else {
                    const presetFilters = this.presetFilters || [];
                    return presetFilters.some(item => {
                        return (
                            (item.dn === 'key' && item.values.length > 0) ||
                            (item.dn === 'mapPath' && item.values.length > 0)
                        );
                    });
                }
            }
        },
        normalizedFilter() {
            const params = {};
            if (this.isSearchCenter) {
                const presetFilter = this.presetFiltersV2 || {};
                return { condition: JSON.stringify(presetFilter) };
            } else {
                this.presetFilters &&
                    this.presetFilters.forEach(filter => {
                        if (filter.dn === 'key') {
                            const value = filter.values
                                .join(filter.split || ',')
                                .split(';');
                            let keyword = [];
                            let keywordType = [];
                            const SPLIT = ';';
                            value.forEach(v => {
                                let arr = v.split(':');
                                keyword.push(arr.slice(1).join(':'));
                                keywordType.push(arr[0]);
                            });
                            params.key = keyword.join(SPLIT);
                            params.keywordType = keywordType.join(SPLIT);
                        } else {
                            params[filter.dn] = filter.values.join(
                                filter.split || ','
                            );
                        }
                    });
            }
            return params;
        }
    },
    data: function() {
        return {
            // hasSearch: false,
            searchParams: {},
            searchModule: null,
            emitCondition: false, //For  emitCondition in beforeMounted, if it's emited in Created, listenter condition maybe undefined;
        };
    },
    created() {
        let searchModule = this.findSearchBarDataByDirection(1, this.id);
        this.searchModule = searchModule;
        if (!searchModule?.data) {
            this.emitCondition = true;
            return;
        }
        if (util.isSSRServer && searchModule.data._csr) {
            return;
        }
        let resolve;
        this.searchParamsReadyPs = new Promise(function(_resolve) {
            resolve = _resolve;
            // 兜底免得卡死
            setTimeout(_resolve, 1500);
        });
        this.unSearchDataReady = searchModule.blockOb?.last?.(SET_SEARCH_DATA_READY, ({ searchParams }) => {
            this.$nextTick(() => {
                this.searchParams = searchParams
                this.emitSearchCondition();
                this.$nextTick(resolve);
            })
        });
        this.unConditionChange = searchModule.blockOb?.last?.('conditionChange', ({ condition = {} }) => {
            this.searchParams = condition;
            this.emitSearchCondition();
        });
        
    },
    mounted() {
        this.emitCondition && this.emitSearchCondition();
    },
    methods: {
        ...rootMapActions(usePageStore, ['findSearchBarDataByDirection']),
        transfer(params) {
            if (util.isObject(params)) {
                if (this.isSearchCenter) {
                    let location = {};
                    Object.keys(params).forEach(type => {
                        if (!location[type]) {
                            location[type] = [];
                        }
                        location[type].push(params[type]);
                    });
                    return {
                        condition: JSON.stringify({
                            location
                        })
                    };
                } else {
                    let keywordType = '';
                    let keyword = '';

                    Object.keys(params).forEach(type => {
                        keywordType = `;${type}`;
                        keyword = `;${params[type]}`;
                    });
                    return {
                        keywordType: keywordType.slice(1),
                        key: keyword.slice(1)
                    };
                }
            } else {
                return {};
            }
        },
        emitSearchCondition() {
            if (!this.searchModule) {
                this.$emit(SEARCH_CHANGE_TYPE, this.normalizedFilter);
                this[SEARCH_CHANGE_TYPE] &&
                    this[SEARCH_CHANGE_TYPE](this.normalizedFilter);
            } else {
                this.$emit(SEARCH_CHANGE_TYPE, this.searchParams);
                this[SEARCH_CHANGE_TYPE] &&
                    this[SEARCH_CHANGE_TYPE](this.searchParams);
            }
        },
        hasSearchBar() {
            return !!this.searchModule;
        },
        getLocation(params) {
            let ret = [];
            if (this.isSearchCenter) {
                if (params.mapArea && params.rect) {
                    return [
                        {
                            keywordType: 'mapArea',
                            keyword: params.rect
                        }
                    ];
                }
                const conditon = JSON.parse(params.condition || '{}');
                const location = conditon.location || conditon.Location;

                if (!location) {
                    return []; 
                }
                ret = Object.keys(location).reduce((memo, keywordType) => {
                    const keys = location[keywordType];
                    for (let key of keys) {
                        memo.push({
                            keywordType,
                            keyword: key
                        });
                    }
                    return memo;
                }, []);
            } else {
                const { key, keywordType, mapPath, mapArea, rect } = params;
                if (mapPath) {
                    return [
                        {
                            keywordType: 'mapPath',
                            keyword: params.mapPath
                        }
                    ];
                }
                if (mapArea && rect) {
                    return [
                        {
                            keywordType: 'mapArea',
                            keyword: rect
                        }
                    ];
                }
                const keyArr = key.split(';');
                const keywordTypeArr = keywordType.split(';');
                for (let i = 0, len = keyArr.length; i < len; i++) {
                    ret.push({
                        keywordType: keywordTypeArr[i],
                        keyword: keyArr[i]
                    });
                }
            }
            return ret;
        }
    },
    beforeDestory() {
        this.unSearchDataReady && this.unSearchDataReady();
        this.unConditionChange && this.unConditionChange();
    }
};
